import React from 'react';
const logo = require('../assets/showroom.png');

export function ShowroomIconButton(props: React.AnchorHTMLAttributes<any>) {
    return (
        <a {...props} className="button is-black">
            <span className="icon is-small">
                <img src={logo} />
            </span>
        </a>
    );
}
